import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IPortalPageSectionItem } from 'models/portal/page/portalpagesectionitem';
import { ISectionImageElement } from 'models/common/sectionimageelement';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import { browserHistory } from 'react-router';
import { CardItemProfileInfo } from 'components';
import { formatInteger, imgSrcAttributes, thumbUrl } from 'helpers/common';
import { FollowButton } from 'components/Common/FollowButton';
require('./style.css');

export interface IProps {
	sectionItem: IPortalPageSectionItem;
	t?: (key: string, options?: any) => string;
	isDragging?: boolean;
	isFollowing?: boolean;
	followItem?: () => void;
	unfollowItem?: () => void;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewSectionItemShop extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.onViewStoreClick = this.onViewStoreClick.bind(this);
	}

	private onViewStoreClick(e: React.SyntheticEvent) {
		e.preventDefault();
		if (!this.props.isDragging) {
			browserHistory.push(`/shop/${(this.props.sectionItem.elements[5] as ISectionTextElement).text}`);
		}
	}

	public render() {
		const { t, followItem, isFollowing, unfollowItem } = this.props;
		const { elements } = this.props.sectionItem;

		const imageUrl = thumbUrl(
			(elements[1] as ISectionImageElement).imageUrl || (elements[0] as ISectionImageElement).imageUrl,
		);

		return (
			<div className="commonItemCard portalPageShopItem">
				<figure
					className="portalPageShopItemImage imageHolder"
					style={imageUrl ? { backgroundImage: 'url("' + imageUrl + '")' } : undefined}
					onClick={(e) => this.onViewStoreClick(e)}
				>
					{imageUrl ? (
						<img {...imgSrcAttributes(imageUrl)} className="withPicture" alt="" />
					) : (
						<span className="noImage" />
					)}
					{followItem ? (
						<FollowButton follow={followItem} unfollow={unfollowItem} isFollowing={isFollowing} fullWidth={true} />
					) : null}
				</figure>
				<CardItemProfileInfo
					name={(elements[2] as ISectionTextElement).text}
					location={(elements[3] as ISectionTextElement).text}
					followersCount={formatInteger(parseInt((elements[6] as ISectionTextElement).text, 10))}
					followersText={t('BSPortal_Common_Followers')}
					description={(elements[4] as ISectionTextElement).text}
					onClick={(e) => this.onViewStoreClick(e)}
				/>
			</div>
		);
	}
}

export { ViewSectionItemShop };
